/*
Vendored + adapted from https://notes.alexkehayias.com/line-clamp-with-react-and-tailwindcss/
 */

import { FunctionComponent, useState, useCallback } from "react";

type TextTruncateProps = {
  text: string,
  scrollTo?: any,
};

/* Note: The number of lines to truncate to needs to be static
otherwise the css classes won't be generated by tailwind. If you need
a different number of lines, create a new component */
export const TextTruncate: FunctionComponent<TextTruncateProps> = ({
  text,
}) => {
    const [shouldTruncate, setShouldTruncate] = useState<boolean>(false);
  const [readMore, setReadMore] = useState<boolean>(false);

  // Measure the element to calculate the number of lines and
  // determine whether to truncate
  const measuredRef = useCallback(
    (node: any) => {
      // Before the component mounts the node ref will be null
      if (node?.parentElement) {
        // Calculate the number of lines based on height
        const elHeight = node.offsetHeight;
        const styles = window.getComputedStyle(node);
        const lineHeight = styles
          .getPropertyValue('line-height')
          .replace('px', '');
        const elLineCount = elHeight / parseInt(lineHeight, 10);

        setShouldTruncate(elLineCount > 3);
      }
    },
    [text]
  );

  const shouldClamp = shouldTruncate && !readMore;
  return (
    <div>
      <p
        ref={measuredRef}
        className={`${shouldClamp ? 'line-clamp-3' : 'line-clamp-none'}`}
      >
        {text}
      </p>
      {shouldTruncate &&
    <button
          className="text-blue-600 hover:underline"
          onClick={() => {
              setReadMore(!readMore)
          }}>
          See {readMore ? "less" : "more"}
      </button>
      }
    </div>
  );
};